import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { catchError, map, Observable, of } from 'rxjs';
import jwt_decode from 'jwt-decode';
import { AlertService } from '../../share/services/alert.service';
import { UserService } from '../../modules/user/user.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard {
  constructor(
    private readonly router: Router,
    private readonly alertService: AlertService,
    private readonly users: UserService,
  ) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): boolean | UrlTree | Observable<boolean | UrlTree> {
    const token = localStorage.getItem('aalulbaytAutomationAccessToken');
    if (!token) return this.router.createUrlTree(['/auth/login']);
    try {
      const decoded = jwt_decode<{ exp: number }>(token);
      if (!decoded.exp || decoded.exp * 1000 <= Date.now()) {
        this.alertService.message('نشست شما به پایان رسیده است');
        return this.router.createUrlTree(['/auth/login']);
      }
    } catch {
      return this.router.createUrlTree(['/auth/login']);
    }
    if (route.routeConfig?.path === 'dashboard') {
      return this.users.getMe().pipe(
        map((user) =>
          user?.role?.[0]?.englishName === 'guest'
            ? this.router.createUrlTree(['/user-subscriptions'])
            : true,
        ),
        catchError(() => of(this.router.createUrlTree(['/auth/login']))),
      );
    }
    return true;
  }
}
